import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom'
import Login from '../pages/login';
import { BallTriangle } from 'react-loader-spinner';

//passa primeiro pelo private antes de entrar na rota, pra garantir que o usuario esteja logado
import Private from './Private';
import PrivateAdmin from './PrivateAdmin';

// Lazy loading - cada página só é carregada quando o usuário navegar até ela
const Home = lazy(() => import('../pages/home'));
const Contracts = lazy(() => import('../pages/contracts'));
const AddClient = lazy(() => import('../pages/contracts/addClient'));
const Finances = lazy(() => import('../pages/finances/index'));
const Cash = lazy(() => import('../pages/cash'));
const Downloads = lazy(() => import('../pages/downloads'));
const ClientsOn = lazy(() => import('../pages/clientsOn/index'));
const ClientsBlocked = lazy(() => import('../pages/clientsBlocked/index'));
const PrintSinteticClient = lazy(() => import('../pages/PrintSinteticClient/index'));
const ReportSintetic = lazy(() => import('../pages/finances/reportSintetic/index'));
const PrintReportCashier = lazy(() => import('../pages/cash/PrintReportCashier'));
const PrintClientsByService = lazy(() => import('../pages/printClientsByService'));
const PrintClientsByRevenda = lazy(() => import('../pages/printClientsByRevenda'));
const PrintClientsContracts = lazy(() => import('../pages/printClientsContracts'));
const Budgets = lazy(() => import('../pages/budgets'));
const AddBudgets = lazy(() => import('../pages/budgets/addBudgets'));
const Terminals = lazy(() => import('../pages/terminals/terminal'));

// Componente de loading enquanto a página carrega
function Loading() {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh'
        }}>
            <BallTriangle
                height={80}
                width={80}
                radius={5}
                color="#F26E22"
                ariaLabel="ball-triangle-loading"
                visible={true}
            />
        </div>
    );
}

function RoutesApp() {
    return (
        <Suspense fallback={<Loading />}>
            <Routes>
                <Route path="/" element={<Login />} />

                <Route path="/home" element={<Private><Home /></Private>} />
                <Route path="/contracts" element={<Private><Contracts /></Private>} />
                <Route path="/addContract" element={<Private><AddClient /></Private>} />
                <Route path="/finances" element={<Private><Finances /></Private>} />
                <Route path="/cash" element={<Private><Cash /></Private>} />
                <Route path="/downloads" element={<Private><Downloads /></Private>} />
                <Route path="/clientsOnOff" element={<Private><ClientsOn /></Private>} />
                <Route path="/clientsblocked" element={<Private><ClientsBlocked /></Private>} />
                <Route path="/clientSintetic" element={<Private><PrintSinteticClient /></Private>} />
                <Route path="/clientsByRevenda" element={<Private><PrintClientsByRevenda /></Private>} />
                <Route path="/clientService" element={<Private><PrintClientsByService /></Private>} />
                <Route path="/clientContracts" element={<Private><PrintClientsContracts /></Private>} />
                <Route path="/reportSintetic" element={<Private><ReportSintetic /></Private>} />
                <Route path="/reportCashier" element={<Private><PrintReportCashier /></Private>} />
                <Route path="/budgets" element={<Private><Budgets /></Private>} />
                <Route path="/addBudgets" element={<Private><AddBudgets /></Private>} />
                <Route path="/terminals" element={<PrivateAdmin><Terminals /></PrivateAdmin>} />
            </Routes>
        </Suspense>
    )
}

export default RoutesApp;